import { render, staticRenderFns } from "./PorletDashboard.vue?vue&type=template&id=48bf325d"
import script from "./PorletDashboard.vue?vue&type=script&lang=js"
export * from "./PorletDashboard.vue?vue&type=script&lang=js"
import style0 from "./PorletDashboard.vue?vue&type=style&index=0&id=48bf325d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports